import { render, staticRenderFns } from "./DefaultDisplay.vue?vue&type=template&id=e5d1e70a&scoped=true&"
import script from "./DefaultDisplay.vue?vue&type=script&lang=js&"
export * from "./DefaultDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d1e70a",
  null
  
)

export default component.exports